<template>
  <div class="mx-2 mt-2">
    <main-group v-for="item in props.products" :key="item.id" :item="item" whole="WoleBtn" />
  </div>
</template>
<script setup>
import { defineProps } from 'vue';
import MainGroup from '../Group/MainGroup.vue';
let props = defineProps(['products']);
</script>
